var espresso = {},
    co3 = {};
( function () {
    'use strict';
    jQuery( function () {
        espresso.bootstrap.init();
        espresso.searching.init();
        espresso.maps.init();
        co3.dw.extranet.init();
        co3.util.scroll.init();
    } );
    jQuery( window ).on( 'load', function () {
        espresso.util.galleries.init();
        espresso.util.cookie.message();
        espresso.newsletterpopup.init();
        espresso.util.toggleGridOverlay();
    } );
}() );

